import * as THREE from 'three';
// import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls.js';
import { CSS2DRenderer } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { Permutohedron, Simplex, braidArrangement } from './geometry.js';
import { Colors } from './colors.js';
import './css/tailwind/before.css';
import './css/style.css';
import './css/tailwind/after.css';


function animate() {
    requestAnimationFrame(animate);
    controls.update();
    render();
}


function render() {
	renderer.render( scene, camera );
    labelRenderer.render( scene, camera );
}


window.addEventListener('resize', () => {
    // camera.aspect = window.innerWidth / window.innerHeight;
    // renderer.setSize(window.innerWidth, window.innerHeight);
    // // renderer.setPixelRatio( window.devicePixelRatio );
    // camera.updateProjectionMatrix();
    const height = container.clientHeight; // Math.min(canvas.clientHeight, window.innerHeight);
    const width = container.clientWidth; //Math.min(canvas.clientWidth, window.innerWidth);
    renderer.setSize(width, height);
    labelRenderer.setSize(width, height);
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
});


function createButton(id, label, obj) {
    let div = document.createElement('div');
    div.className = 'toggle-btn-container';
    let inp = document.createElement('input');
    inp.type = 'checkbox';
    inp.name = id;
    inp.id = id;
    inp.className = 'toggle-checkbox';
    let lbl = document.createElement('label');
    lbl.className = 'toggle-label';
    lbl.setAttribute('for', id);
    div.appendChild(inp);
    div.appendChild(lbl);
    let outerDiv = document.createElement('div');
    outerDiv.className = 'toggle-btn-grp';
    outerDiv.appendChild(div);
    let outerLbl = document.createElement('label');
    outerLbl.className = 'toggle-label-outer';
    outerLbl.setAttribute('for', id);
    outerLbl.innerText = label;
    outerDiv.appendChild(outerLbl);

    outerDiv.addEventListener('change', function(e) {
        if ( e.target.checked ) {
            if ( e.target.id === 'perm' ) {
                for ( let lbl of p.labels ) {
                    lbl.style.visibility = 'visible';
                }
            }
            scene.add(obj);
        }
        else {
            if ( e.target.id === 'perm' ) {
                for ( let lbl of p.labels ) {
                    lbl.style.visibility = 'hidden';
                }
            }
            scene.remove(obj);
        }
    });
    return outerDiv;
}


const canvas = document.getElementById('canvas');
const container = document.getElementById('container');
const buttons = document.getElementById('buttons');


const renderer = new THREE.WebGLRenderer({canvas, antialias: true});
renderer.setClearColor("#efeffa");
renderer.setSize(canvas.clientWidth, canvas.clientHeight);
renderer.setPixelRatio( window.devicePixelRatio );

container.appendChild(renderer.domElement);

let	labelRenderer = new CSS2DRenderer(renderer.domElement);
labelRenderer.setSize( canvas.clientWidth, canvas.clientHeight );
labelRenderer.domElement.style.position = 'absolute';
labelRenderer.domElement.style.top = '0px';
labelRenderer.domElement.style.pointerEvents = 'none';

container.appendChild(labelRenderer.domElement);


const camera = new THREE.PerspectiveCamera( 50, window.innerWidth / window.innerHeight, .1, 2000 );
const campos = [5, 5, 3];
camera.position.set(...campos);
camera.lookAt(new THREE.Vector3(0, 0, 0));

const controls = new OrbitControls(camera, renderer.domElement);
// const controls = new TrackballControls(camera, renderer.domElement);

const scene = new THREE.Scene();

const ambientLight = new THREE.AmbientLight( 0xd1d1d1 );
scene.add( ambientLight );

let colors = new Colors();

let p = new Permutohedron([0, 0, 0], 4, 1., colors.colors, .1, false);
let pobj = new THREE.Group();
pobj.add(p.polytope);
pobj.add(p.vertices);

let ba = braidArrangement(.9);

let s = new Simplex([0,0,0], 4, 1., colors.colors);
let sobj = new THREE.Group();
sobj.add(s.constructBarycentric());

animate();

let permBtn = createButton('perm', 'Permutohedron', pobj);
let simplexBtn = createButton('simp', 'Simplex', sobj);
let braidBtn = createButton('braid', 'Braid Arrangement', ba);

buttons.appendChild(permBtn);
buttons.appendChild(simplexBtn);
buttons.appendChild(braidBtn);

window.onload = function() {
    document.getElementById('perm').click();
};
